import { render, staticRenderFns } from "./MangelListeHelp.vue?vue&type=template&id=800564b4&"
import script from "./MangelListeHelp.vue?vue&type=script&lang=ts&"
export * from "./MangelListeHelp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports